export function useClearConsigneeContact(modelValue) {

    modelValue.consignee.consigneeContactId = 0;
    modelValue.consignee.consigneeContactFullName = '';
    modelValue.consignee.consigneeContactTitle = '';
    modelValue.consignee.consigneeContactFirstName = '';
    modelValue.consignee.consigneeContactLastName = '';
    modelValue.consignee.consigneeContactPhone = '';
    modelValue.consignee.consigneeContactEmail = '';

}
